// extracted by mini-css-extract-plugin
module.exports = {"list":"CompanyList_list__Ql9Dq"};